import { combineReducers } from "@reduxjs/toolkit";
import campaign from "./campaign";
import phases from "./phases";
import common from "./common";
import loader from "./loader";
import task from "./task";
import customCampaign from "./customCampaign";
import cart from "./cart";
import assistant from "./assistance";
import tourGuide from "./tourGuide";

// Combine reducers
const appReducer = combineReducers({
  campaign: campaign,
  phases: phases,
  common: common,
  loader: loader,
  task: task,
  customCampaign: customCampaign,
  cart: cart,
  assistant: assistant,
  tour: tourGuide
});

// Root reducer with RESET_STORE handling
const rootReducer = (state, action) => {
  // If the action type is RESET_STORE, reset the state
  if (action.type === "RESET_STORE") {
    state = undefined; // Reset the state to undefined
  }
  return appReducer(state, action);
};

export default rootReducer;
